import * as React from "react";
import { useEffect } from "react";
import { style } from "typestyle";
import { Dialog, DialogContent, DialogFooter, DialogTitle } from "./dialog.js";
import { PushButton } from "./PushButton.js";
export function ErrorMessageDialog({ title, description, onClose }) {
    useEffect(() => {
        if (title) {
            const autoCloseTimer = setTimeout(() => {
                onClose();
            }, 20000);
            return () => {
                clearTimeout(autoCloseTimer);
            };
        }
    }, [title, onClose]);
    return (React.createElement(Dialog, { open: true, onBackdropClick: onClose },
        React.createElement("div", { className: style({ width: "45em", color: 'red', background: 'white' }) },
            React.createElement(DialogTitle, null, title),
            React.createElement(DialogContent, null, description),
            React.createElement(DialogFooter, null,
                React.createElement(PushButton, { onClick: onClose }, "OK")))));
}
//# sourceMappingURL=ErrorMessageDialog.js.map